module.exports = __webpack_public_path__ + "static/media/aboutus.95a6547b.png";